import { InjectionToken } from '@angular/core';

export const InReport=new InjectionToken<boolean>('InReport');
export class ReportService{
	public orientation:'portrait'|'landscape'='portrait';
}